import React from 'react';
import PropTypes from 'prop-types';
import SimilarVideoContent from './SimilarVideoContent.js';
import { useQuery } from 'urql';
import QUERY from './SimilarVideoContentQuery.graphql';

const SimilarVideoContentContainer = ({ titleArticleId }) => {
    const [result] = useQuery({
        query: QUERY,
        variables: {
            id: titleArticleId,
        },
    });

    if (!result?.data) {
        return null;
    }

    const { data } = result;
    const associatedContentLists = data.detailsPage?.associatedContent;

    if (associatedContentLists.length === 0) {
        return null;
    }

    const associatedContent = associatedContentLists[0];

    const listTracking = {
        listID: associatedContent?.analyticsIdentifiers?.listId,
        listType: associatedContent?.analyticsIdentifiers?.listType,
    };

    return (
        <SimilarVideoContent
            key={titleArticleId}
            headerText={associatedContent.name}
            listContent={associatedContent.items}
            titleArticleId={titleArticleId}
            listTracking={listTracking}
        />
    );
};

SimilarVideoContent.propTypes = {
    titleArticleId: PropTypes.string,
};

export default SimilarVideoContentContainer;
